// $(document).ready(function(){
//   $(".new-listing__left").on("mouseenter", "a.nav-item.nav-link", function() {
//     var e = $(this).attr("data-id"),
//         currentMegaMenu = $(this).closest(".new-mega-menu"),
//         activeTab = currentMegaMenu.find(".mega-menu__tab .tab-pane.active");

//     // Remove 'active' and 'show' classes from all tabs
//     $(".mega-menu__tab .tab-pane").removeClass("active");

//     // Add 'active' and 'show' to the target tab based on the data-id
//     $("#" + e).addClass("active");

//     // Remove the 'active' class from all nav items and add it to the hovered one
//     currentMegaMenu.find("a.nav-item.nav-link").removeClass("active");
//     $(this).addClass("active");
// });

// // $(".new-listing__right").on("mouseenter", ".tab-pane", function() {
// //     $(this).addClass("active show");
// // });

// // Handle mouseleave to remove the 'active' and 'show' classes
// $(".new-listing__left").on("mouseleave", function() {
//     var currentMegaMenu = $(this).closest(".new-mega-menu");

//     // Remove 'active' and 'show' classes from all tabs
//     $(".mega-menu__tab .tab-pane").removeClass("active");

//     // Remove 'active' class from all nav items
//     $("a.nav-item.nav-link").removeClass("active");

//     // Optionally, reset to the first tab and first nav item if desired
//     currentMegaMenu.find(".mega-menu__tab .tab-pane").first().addClass("active");
//     currentMegaMenu.find("a.nav-item.nav-link").first().addClass("active");
// });
// });


$(document).ready(function() {
            $(".new-listing__left a.nav-item.nav-link").on("mouseover", function() {
                var e = $(this).attr("data-id");
                $(".new-listing__right .mega-menu__tab .tab-pane.new-active").removeClass("new-active");
                $("#" + e).addClass("new-active");
                $(".new-listing__left a.nav-item.nav-link").removeClass("new-active");
                $(this).addClass("new-active");
            });

  // variant popup js start here 
      $('.custom-product__variant-inner').click(function(){
          $('body').addClass('popup-active');
          $('.variant-popup').addClass('popup-active');
      });
  $('.close-icon-popup').click(function(){
          $('body').removeClass('popup-active');
          $('.variant-popup').removeClass('popup-active');
      });
  $(document).click(function(event) {
    if (!$(event.target).closest('.variant-popup, .custom-product__variant-inner').length) {
        $('body').removeClass('popup-active');
        $('.variant-popup').removeClass('popup-active');
    }
    // Find the active element within the list
  const activeItem = document.querySelector('.variant-popup__bottomcontent ul li.active');
  
  if (activeItem) {
    // Find the container that has the fixed height and overflow scroll
    const container = document.querySelector('.variant-popup__bottomcontent');
    
    // Scroll the active item into view within the container
    activeItem.scrollIntoView({
      behavior: 'smooth', // Smooth scroll
      block: 'center',    // Align the element to the center of the container
    });
  }
});
  $('.variant-popup__bottomcontent').on('click', 'ul li', function(){
    $(this).addClass('active').siblings().removeClass('active'); // Add class to clicked li and remove from others
    
});
  
  });


$(document).ready(function() {
    // Toggle the main submenu with slide effect
    $('.submenu > a').click(function(e) {
        e.preventDefault(); // Prevent default link behavior
        var submenuWrapper = $(this).next('.submenu-wrapper');
        
        // Slide up all submenus and slide down the clicked one
        $('.submenu-wrapper').not(submenuWrapper).slideUp(); // Close other submenus
        submenuWrapper.stop(true, true).slideToggle(); // Toggle the clicked submenu
    });

    // Toggle the subchild menu with slide effect
    $('.subchild-menu > a').click(function(e) {
        e.preventDefault(); // Prevent default link behavior
        var subChildMenu = $(this).next('.sub-childmenu');
        
        // Slide up all subchild menus and slide down the clicked one
        $('.sub-childmenu').not(subChildMenu).slideUp(); // Close other subchild menus
        subChildMenu.stop(true, true).slideToggle(); // Toggle the clicked subchild menu
    });
});

